module.exports = __webpack_public_path__ + "static/media/icon_group_orange.0e219db3.svg";